import { useInfiniteQuery, useQueryClient } from '@tanstack/react-query';
import { IPost, fetchPostsByUserId } from '@/lib/community';

const PAGE_SIZE = 10;

export function useUserPosts(userId: string) {
	
	const {
		data,
		fetchNextPage,
		hasNextPage,
		isFetchingNextPage,
		isLoading,
		refetch,
	} = useInfiniteQuery<IPost[], unknown, { pages: IPost[][]; pageParams: number[]; }, [string, string], number>({
		queryKey: ['user-posts', userId],
		queryFn: ({ pageParam = 0 }) => fetchPostsByUserId({ userId, pageParam, pageSize: PAGE_SIZE }),
		getNextPageParam: (lastPage, allPages) =>
			lastPage && lastPage.length === PAGE_SIZE
				? allPages.length * PAGE_SIZE
				: undefined,
		initialPageParam: 0,
	});

	const posts = data ? data.pages.flat() : [];

	return {
		posts,
		fetchNextPage,
		hasNextPage,
		isFetchingNextPage,
		isLoading,
		refetch,
	};
}
